import { atom } from 'recoil';

export const entityBulkDetailsDrawerOpenState = atom({
    key: 'entityBulkDetailsDrawerOpenState',
    default: false,
});
